import { render, staticRenderFns } from "./RoleUserEdit.vue?vue&type=template&id=cfbdadb8&scoped=true"
import script from "./RoleUserEdit.vue?vue&type=script&lang=js"
export * from "./RoleUserEdit.vue?vue&type=script&lang=js"
import style0 from "./RoleUserEdit.vue?vue&type=style&index=0&id=cfbdadb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfbdadb8",
  null
  
)

export default component.exports